var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_w-max"},[_c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.agent_info.my_banner.url}})]),_c('warehouse-address'),_c('contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }